import compose from 'ramda/src/compose.js'
import identity from 'ramda/src/identity.js'
import count from 'ramda/src/count.js'
import uniq from 'ramda/src/uniq.js'
import flatten from 'ramda/src/flatten.js'

export const uniqList = compose( uniq, flatten );

export const toArray = x => Array.isArray( x ) ? x : [x];

export const countArrays = ( ...list ) => count( identity, flatten( list ) )

export const groupBySize = ( arr = [], size = 1 ) => {
    const groups = [];
    for ( let i = 0; i < arr.length; i += size ) {
        const chunk = arr.slice( i, i + size );
        groups.push( chunk );
    }

    return groups;
}

